import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    Setting,
    TibboDataType,
    SettingType,
} from '@appblocks/codegeneration/types';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';

export default class Tibbit40Node extends BaseNode {
    range = 5000;

    constructor() {
        super();

        this.inputs = [
            {
                name: 'Set Ohm',
                portId: 'tibbit40_set_ohm',
                params: [
                    {
                        name: 'impedance',
                        dataType: TibboDataType.DWORD,
                        default: '0',
                    },
                    // {
                    //     name: 'range',
                    //     dataType: TibboDataType.DWORD,
                    //     default: '10000',
                    // },
                ],
            },
        ];
    }

    getRange(): number {
        return this.range;
    }

    getCodeBlocks(): CodeBlock[] {
        const blocks: CodeBlock[] = [];
        const project: ProjectConfiguration = this.project;
        const tibbit = project.getFeature(this.getSettingValue('TIBBIT'));
        if (!tibbit) {
            return blocks;
        }
        const channelName = `${tibbit.getSettingValue('NAME')}_CHANNEL`;

        const links = project.getNodeLinks(this, 'tibbit40_set_ohm');
        for (let i = 0; i < links.length; i++) {
            const link = links[i];
            blocks.push({
                location: link.getSourceId(),
                blockType: BlockType.CODE,
                id: link.getID(),
                template: `tbt40_set_ohm(${project.getNodeParameter(link, 'impedance')}, ${this.getRange()},NO,${channelName})`,
            });
        }

        return blocks;
    }
}
